<template>
  <div class="footer">
    <div class="copy">
      <img src="https://s.moimg.net/dist/img/logo-grey.png" />
      <div class="intro">
        <p>Copyright © 2014-{{ current_year }} MoDian All Rights Reserved</p>
        <p>北京摩点会想科技有限公司</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      current_year: new Date().getFullYear()
    }
  },
  methods: {
    goLink(link) {
      if (link) {
        location.href = link
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.footer {
  background: #F2F2F2;

  .copy {
    width: 1080px;
    height: 90px;
    margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: center;
    border-bottom: 1px solid #E8E8E8;

    img {
      width: 94px;
      margin-right: 20px;
    }

    .intro {
      padding: 0 0 0 20px;
      border-left: 1px solid #DEE0E1;

      p {
        font-size: 12px;
        font-family: PingFang SC-常规体, PingFang SC;
        font-weight: normal;
        color: #7F7F7F;
        line-height: 16px;
      }
    }
  }
}
</style>